'use strict';

// import {siteConfig} from '../siteConfig';

module.exports = function($uibModal, dialog, Department, Member, $state, departments, $translate, myTenant) {
    var _this = this;
    _this.tagSync = {
        idGoogleSheet: $state.params.idGoogleSheet,
        sheetName: $state.params.sheetName,
    }

    // TENANT VOOLKS CERTIFICATIONS
    this.myTenant = myTenant;
    _this.myTenant.load().then(() => {
        this.tenantId = _this.myTenant.get().id;
    })

    this.department = departments?.filter(function(department) {
        return department.id === $state.params.departmentId;
    })[0];

    // MODAL TAG SYNC
    this.syncModal = function() {
        console.log('syncModal')
        $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-department-admin-tagsync/dashboardDepartmentTagsSyncModal.html',
            controller: [
                "$uibModalInstance",                
                "Department",
                "toast",
                "$translate",
                "myDepartments",
                "department",
                "$timeout",
                function ($uibModalInstance, Department, toast, $translate, myDepartments, department, $timeout) {
                    var _this = this;
                    this.loading = false;
                    this.syncSuccess = false;
                    _this.department = department;
                    _this.reloadingData = false;

                    _this.tagSync = {
                        idGoogleSheet: $state.params.idGoogleSheet,
                        sheetName: $state.params.sheetName,
                    }
                    // console.log('modal tagSync', _this.tagSync)

                    // LLAMAR ENDPOINT
                    this.syncData = () => {
                        _this.loading = true;

                        Department.TagSync(
                            { departmentId: _this.department.id,},
                            {
                                spreadsheetId: _this.tagSync.idGoogleSheet,
                                range: _this.tagSync.sheetName
                            }
                        )
                        .$promise
                        .then(function (result) {
                            console.log('result', result)
                            if (result?.response?.status == 'ok') {
                                $timeout(() => {
                                    _this.loading = false;
                                    _this.syncSuccess = true;
                                }, 0);
                                toast.success($translate.instant('Importado con exito'));
                            } else {
                                _this.loading = false;
                                _this.syncSuccess = false;
                                toast.error($translate.instant('Error'));
                            }
                           
                        })
                        .catch(function (error) {
                            _this.loading = false;
                            _this.syncSuccess = false;
                            toast.error($translate.instant('Error al importar supervisores y etiquetas'));
                            console.log(error);
                        });
                    }

                    this.close = function () {
                        $uibModalInstance.close();     
                    };

                    this.returnToAdmin = () => {
                        $timeout(() => {
                            _this.loading = true;
                            _this.reloadingData = true;
                        }, 0);
                        myDepartments.load().then(function(dpts){
                            _this.loading = false;
                            $uibModalInstance.close({return: true}); 
                        });   
                    }
                },
            ],
            controllerAs: "modal",
            size: "md",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                department: () => this.department,
            }
        }).result.then((result) => {
            if (result?.return) {
                $state.go("dashboard.departments.department.admin", {departmentId: _this.department.id}, {reload: true});
            }
        }, function() {
        });
    };

    this.close = () => {
        $state.go("dashboard.departments.department.admin", {
            departmentId: _this.department.id
        });
    }
};
